import {
  LeadsStatusesListData,
  leadsStatusesListInfiniteOptions,
  LeadsTypesListData,
  leadsTypesListInfiniteOptions,
  LeadTypeReadable,
  PaginatedReturnLeadStatusListReadable,
  PaginatedReturnLeadTypeListReadable,
  ReturnLeadStatusReadable
} from '@crm/api'
import { InfiniteSelect } from '@crm/components'
import { listTransformResults } from '@crm/utils'
import { FormColorPicker } from '@shared/components'
import { useLocales } from '@shared/locales'
import { Checkbox, Form, FormInstance, Input } from 'antd'

type Props = {
  form: FormInstance
}

export const FormNomenclaturesLeadStatus = ({ form }: Props) => {
  const { t } = useLocales()

  const leadType = Form.useWatch('lead_type', form)

  return (
    <>
      <Form.Item
        name="name"
        label={t('nomenclature.name')}
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="code"
        label={t('nomenclature.code')}
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>

      <FormColorPicker
        itemProps={{
          label: t('nomenclature.color')
        }}
        showText
      />

      <Form.Item
        name="order"
        label={t('nomenclature.order')}
        rules={[{ required: true }]}
      >
        <Input type="number" />
      </Form.Item>

      <Form.Item name="lead_type" label={t('contacts.lead_type')}>
        <InfiniteSelect<
          LeadsTypesListData,
          PaginatedReturnLeadTypeListReadable,
          LeadTypeReadable
        >
          popupMatchSelectWidth
          placeholder={t('main.select')}
          getQueryFunction={leadsTypesListInfiniteOptions}
          getOptions={({ options }) => listTransformResults(options)}
          baseOptions={{
            query: {
              preference: leadType ? [leadType] : undefined
            }
          }}
        />
      </Form.Item>

      <Form.Item
        name="allowed_transition_statuses"
        label={t('nomenclature.allowed_transition_status_codes')}
        tooltip={t('nomenclature.allowed_transition_status_codes_hint')}
      >
        <InfiniteSelect<
          LeadsStatusesListData,
          PaginatedReturnLeadStatusListReadable,
          ReturnLeadStatusReadable
        >
          mode="multiple"
          popupMatchSelectWidth
          placeholder={t('main.select')}
          getQueryFunction={leadsStatusesListInfiniteOptions}
          getOptions={({ options }) =>
            options.map(({ id, name }) => ({ value: id, label: name }))
          }
        />
      </Form.Item>

      <Form.Item
        name="requires_refusal_reason"
        label={t('nomenclature.requires_refusal_reason')}
        valuePropName="checked"
        initialValue={false}
      >
        <Checkbox />
      </Form.Item>

      <Form.Item
        name="requires_opportunity"
        label={t('nomenclature.creates_opportunity')}
        valuePropName="checked"
        initialValue={false}
      >
        <Checkbox />
      </Form.Item>

      <Form.Item
        name="is_default"
        label={t('nomenclature.is_default')}
        valuePropName="checked"
        initialValue={false}
      >
        <Checkbox />
      </Form.Item>
    </>
  )
}
